import { Observable } from 'rxjs';
import { AdditionalDataKey } from '../domain/models';
import { Injectable } from "@angular/core";

@Injectable({providedIn: 'root'})
export abstract class AdditionalDataKeysRepository {
  abstract getAdditionalDataKeys(
    params: string | undefined
  ): Observable<AdditionalDataKey[]>;

  abstract getAdditionalDataKey(
    params: string | undefined
  ): Observable<AdditionalDataKey>;
}
